import axios from 'axios';
import { setupRequestInterceptor, setupResponseInterceptor } from './interceptors';

const realtimeAxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_REALTIME_API_URL || 'https://tcx-dev-realtime-data-source.azurewebsites.net/api',
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupRequestInterceptor(realtimeAxiosInstance);
setupResponseInterceptor(realtimeAxiosInstance);

export default realtimeAxiosInstance;
